import React from 'react'
import "./Everest-Heli.css"
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCalendarCheck,faPhotoFilm,faSliders,faBolt,faCheck,faStar,faXmark, faDownload, faMinus, faPlus, faTag,faEnvelope ,faCalendarDays, faCloud, faGaugeHigh, faArrowRight,faBus, faMapLocationDot, faHotel, faMessage, faSquareArrowUpRight,faChevronDown, faMicrophone,faChevronUp, faBowlFood, faMountain} from '@fortawesome/free-solid-svg-icons'
import { faWhatsapp,faWeixin,} from '@fortawesome/free-brands-svg-icons'
import { useState } from 'react'
import {useEffect}from 'react'
import PackageSlider from "./Component/PackageSlider";
import Bookingform from "./Component/bookingform";
import Enquiryform from "./Component/enquiryform";
import Review from "./Component/review";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import TourNav from './Component/stickynav';
const packages = [
  {
    title: "7 Unesco Heritage Tour",
    days: "4 Hours",
    duration: "8-9 Hours",
    difficulty: "Easy",
    price: 190,
    image: "/img/capital/pasupatinath.jpg",
    link: "/one-day-nepal-7unescoheritage-tour"
  },
  {
    title: "Nepal Golden Triangle Tour",
    location: "Nepal",
    days: "8 Days",
    difficulty: "Easy",
    price: 940,
    duration: "8 Days",
    image: "/img/chitwan/chitwan3dslr.jpeg",
    link: "/kathmandu-chitwan-pokhara-8days-nepaltour"
  },
  {
    title: "Mountain Flight",
    days: "1 Hours",
    duration: "1 Hours",
    difficulty: "Easy",
    price: 280,
    image: "/img/mounteve/moun1.webp",
    link: "/mountain-flight-nepal-tour"
  },
  {
    title: "Nature Majestic Loop",
    location: "Nepal",
    days: "10 Days",
    difficulty: "Easy",
    price: 2350,
    duration: "10 Days",
    image: "/img/treek/Dhampus.webp",
    link: "/kathmandu-chitwan-lumbini-pokhara-ghandrukh-dhampush-bandipur-nagarkot-10daystour"
  }
];
const images = [
  "/img/company/airportdslr.jpeg",
  "/img/chitwan/chitwan1dslr.jpeg",
  "/img/chitwan/canoing.jpeg",
  "/img/chitwan/chitwan5dslr.jpeg",
  "/img/company/groupphoto.jpeg",
  "/img/chitwan/chitwan2dslr.jpeg",
  "/img/chitwan/chitwan4dslr.jpeg",
  "/img/company/me1dslr.jpeg",
  "/img/chitwan/chitwan7dslr.jpeg",
  "/img/chitwan/chitwan6dslr.jpeg",
  "/img/chitwan/chitwan8dslr.jpeg",
  "/img/chitwan/chitwandslr.jpeg",
  "/img/capital/pro.png",
  "/img/capital/swyambhunath1dslr.jpeg",
  "/img/capital/bouddha.webp",
  "/img/capital/pasupatinath.jpg",
  "/img/capital/image-asset.webp",
  "/img/capital/capitaldslr.jpeg",
  "/img/capital/kathmandu2.jpg",
  "/img/company/mewith.jpeg",
  "/img/company/medslr.jpeg",
  "/img/pokhara/pokhara1dslr.jpeg",
  "/img/pokhara/pokhara4.jpg",
  "/img/pokhara/pokharadslr.jpeg",
  "/img/capital/myself.jpg",
  "/img/pokhara/pokhara2dslr.jpeg",
  "/img/pokhara/tal barahi.webp",
  "/img/pokhara/pokh.jpg",
  "/img/capital/Nagarkot.avif",
  
];
const KathmanduchitwannagarkotTour = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [count,Setcount]=useState(1);
  const [day1Open, setDay1Open] = useState(false);
  const [day2Open, setDay2Open] = useState(false);
  const [day3Open, setDay3Open] = useState(false);
  const [day4Open, setDay4Open] = useState(false);
  const [day5Open, setDay5Open] = useState(false);
  const [day6Open, setDay6Open] = useState(false);
  const next = () => {
    setIndex((index + 1) % images.length);
  };

  const prev = () => {
    setIndex((index - 1 + images.length) % images.length);
  };
  const getmul=(qty)=>{
    if(qty===1)return 1150;
if(qty>=2)return 715;
if(qty>=3 && qty<=5)return 640;
if(qty>=6 && qty<=8)return 605;
if(qty>=9)return 580;
    };
    const totalprice =count*getmul(count);
    const [opent, seT] = useState(false);
    const [opente, seTe] = useState(false);
    const [openr, seTr] = useState(false);
    const [openH, seTh] = useState(false);
    useEffect(()=>{
      if(opent){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[opent]);
    useEffect(()=>{
      if(openH){
        document.body.style.overflow='hidden';
      }
      else{
        document.body.style.overflow='unset';
      }
      return()=>{
        document.body.style.overflow='unset';
      }
    },[openH]);
    const [activeIndex, setActiveIndex] = useState(null);
    
      const toggleFaq = (index) => {
        if (activeIndex === index) {
          setActiveIndex(null);
        } else {
          setActiveIndex(index);
        }
      };
  return (
   <main>
 <TourNav />
    <div className='main'>
    <div className='Left'>
    <h1 className="tourTitle">Peak & Safaris</h1>

    <div className="breadcrumb">
    Kathmandu-Chitwan-Nagarkot <span>6 Days Tour</span>
    </div>
     <div className="everest-image">
        <div className="everest-full">
          <img src="/img/chitwan/Chitwan.jpg" alt="error" />
          <div
      className="tourgps"
      onClick={() => setOpen(true)}
    >  <FontAwesomeIcon icon={faPhotoFilm}></FontAwesomeIcon> View Gallery
       </div>
        </div>
        <div className="everest-half">
            <div className="image-box"> <video src="/video/videodslr.mp4" controls autoPlay muted loop></video></div>
            <div className="image-box"> <img src="/img/capital/bouddha.webp" alt="error" /></div>
        </div>
     </div>
     {open && (
  <div className="roomModal tourgr">
    <div className="roomModal__content">

      <div
        className="roomModal__close"
        onClick={() => setOpen(false)}
      >
        ✕
      </div>

      <img
        src={images[index]}
        alt="big"
        className="roomModal__image"
      />
      <div
        className="roomModal__nav roomModal__nav--left"
        onClick={prev}
      >
        ❮
      </div>

      <div
        className="roomModal__nav roomModal__nav--right"
        onClick={next}
      >
         ❯  
      </div>

      <div className="roomModal__thumbs">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="thumb"
            className={
              index === i
                ? "roomModal__thumb active"
                : "roomModal__thumb"
            }
            onClick={() => setIndex(i)}
          />
        ))}
      </div>

    </div>
  </div>
)}
    <div className="Trip-fact">
      <h3>Trip Facts</h3>
      <div className="grid">
        <div className="grid-item">
          <FontAwesomeIcon icon={faCalendarDays}/>
          <div className="grid-item-next">
            <p className='Dur'>Duration</p>
            <p className='Duration'>6 Days</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faCloud}/>
          <div className="grid-item-next">
            <p className='Dur'>Best Time</p>
            <p className='Duration'>Whole Year</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faGaugeHigh}/>
          <div className="grid-item-next">
            <p className='Dur'>Grade</p>
            <p className='Duration'>Easy</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faBus}/>
          <div className="grid-item-next">
            <p className='Dur'>Transportation</p>
            <p className='Duration'>Private Vehical</p>
          </div>
        </div>
 
        <div className="grid-item">
          <FontAwesomeIcon icon={faMapLocationDot}/>
          <div className="grid-item-next">
            <p className='Dur'>Type Of Tour</p>
            <p className='Duration'>Exploring Natural Beauty and Culture</p>
          </div>
        </div>

         <div className="grid-item" onClick={()=>seTh(true)}>
          <FontAwesomeIcon icon={faHotel}/>
          <div className="grid-item-next">
            <p className='Dur'>Hotel Included</p>
            <p className='Duration'>4 And 5 Star (Changeable)</p>
          </div>
        </div>
        <div className="grid-item">
          <FontAwesomeIcon icon={faBowlFood}/>
          <div className="grid-item-next">
            <p className='Dur'>Breakfast</p>
            <p className='Duration'>Included</p>
          </div>
        </div>

        <div className="grid-item">
          <FontAwesomeIcon icon={faMountain}/>
          <div className="grid-item-next">
            <p className='Dur'>Maximum Elevation</p>
            <p className='Duration'>2100 M</p>
          </div>
        </div>

      </div>

       </div>
   <div className="overview-container"id='overview'>
  <div className="heading">Highlights Of Tours</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Stunning Himalayan sunrise views over Everest from Nagarkot hilltop.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Thrilling wildlife Jeep safari in Chitwan National Park.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Explore UNESCO World Heritage sites across ancient Kathmandu.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Scenic sunset canoeing on the peaceful Rapti River.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Discover medieval Newari architecture in historic Bhaktapur city.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Experience vibrant traditional Tharu cultural dance performances.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faSquareArrowUpRight} style={{color:"green", fontSize:'24px'}}/> Visit sacred Pashupatinath Temple and the massive Boudhanath Stupa.</p>
  </div>
</div>
      <div className="overview-container">
  <div className="overview-heading">Overview</div>

  <div className="overview-text">
    Embark on a definitive 6-day journey through Nepal’s most iconic destinations, seamlessly blending the spiritual heritage of **Kathmandu**, the wild adventures of **Chitwan**, and the Himalayan granduer of **Nagarkot**. This tour is meticulously crafted to showcase the best of Nepal, moving from ancient UNESCO temples and medieval cities to subtropical jungles and high-altitude viewpoints. It is the perfect balance of cultural immersion, wildlife encounters, and serene mountain vistas.
  </div>

  <div className="heading smalling">Places You’ll Visit:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Bouddhanath Stupa:</b> The massive mandala-style stupa that serves as the spiritual heart of Tibetan Buddhism.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Swayambhunath (Monkey Temple):</b> An ancient religious complex offering panoramic views over the Kathmandu Valley.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Bhaktapur Durbar Square:</b> A medieval UNESCO city renowned for its 55-window palace and artistic woodcarvings.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Chitwan National Park:</b> A lush sanctuary where you will explore dense jungles in search of rhinos and tigers.</p>
    <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Nagarkot Hill Station:</b> The premier ridge-top destination for viewing the sunrise over the Everest and Langtang ranges.</p>
  </div>

  <div className="heading smalling">Introduction Of Places</div>

  <p className='overview-text'><b>Pashupatinath: The Eternal Flame</b> On the banks of the Bagmati River, this temple is a powerful testament to life and death. With its golden roofs and silver doors, it is a place where ancient rituals meet the daily flow of faith, offering a profound spiritual experience that is uniquely Nepali.</p>

  <p className='overview-text'><b>Boudhanath: The Circle of Peace</b> Stand before the massive white dome and the watchful eyes of the Buddha. As you walk with the pilgrims in a clockwise circle, the smell of incense and the hum of "Om Mani Padme Hum" creates a meditative atmosphere that calms the busiest of minds.</p>

  <p className='overview-text'><b>Chitwan National Park: Into the Wild</b> Leave the city behind for the tall grasslands and riverine forests of the south. Whether on a jeep safari or walking through the woods, the thrill of spotting a rare rhino or exotic birds in their natural habitat is an adventure you will never forget.</p>

  <p className='overview-text'><b>Rapti River: The Jungle’s Mirror</b> Drift silently in a hand-carved canoe as the jungle wakes up. The river is a lifeline for crocodiles sunning on the banks and kingfishers diving for their morning catch. It is the most peaceful way to witness the raw beauty of Chitwan's ecosystem.</p>

  <p className='overview-text'><b>Tharu Village & Culture: Heart of the Terai</b> Meet the resilient Tharu people, whose culture is deeply intertwined with the jungle. Their traditional mud-walled houses and the rhythmic "Stick Dance" performed in the evenings tell a story of harmony between humans and the wild.</p>

  <p className='overview-text'><b>Phewa Lake: The Soul of Pokhara</b> Life in Pokhara revolves around this tranquil lake. Paddling a colorful wooden boat toward the Tal Barahi temple island, with the Himalayas towering in the background, provides a sense of freedom and quiet wonder that defines the Nepal experience.</p>

  <p className='overview-text'><b>Sarangkot: Above the Clouds</b> Rising early for Sarangkot is a rite of passage. As the sun peeks over the horizon, the Annapurna and Dhaulagiri ranges transform from ghostly white to brilliant orange, offering a panoramic spectacle that feels close enough to touch.</p>

  <p className='overview-text'><b>Davis Fall: The Hidden Torrent</b> Locally known as Patale Chhango, this waterfall is a geological marvel. The water crashes through a narrow gorge and vanishes into the ground, creating a thunderous sound that echoes the power of Himalayan snowmelt.</p>

  <p className='overview-text'><b>Gupteshwar Mahadev Cave: The Sacred Depth</b> Descend into the cool, dark belly of the earth to find a temple hidden inside a cave. This natural limestone formation features intricate stalactites and leads to a viewpoint where you can see the base of Davis Fall from underground.</p>

  <p className='overview-text'><b>Swayambhunath: The Valley Sentinel</b> Perched atop a hill, this stupa is a mosaic of fluttering prayer flags and playful monkeys. It is the perfect place to watch the sun set over the sprawling city of Kathmandu, reflecting on a journey that spans from the depths of the jungle to the peaks of the sky.</p>
  <p className='overview-text'><b>Nagarkot Himalayan Sunrise:</b> Conclude your journey on the ridge of Nagarkot. Waking up early rewards you with a breathtaking 360-degree panorama as the sun illuminates the snow-capped peaks of the central Himalayas.</p>
</div>


<div className="overview-container">
  <div className="overview-heading">Why This Package?</div>

  <div className="heading smalling">The Ultimate Nepal Trio</div>
  <p className='overview-text'>Why choose one when you can have it all? This package perfectly balances the ancient heritage of Kathmandu, the wild adventure of Chitwan, and the serene mountain views of Nagarkot in one seamless 6-day journey.</p>

  <div className="heading smalling">Thrilling Wildlife Encounters</div>
  <p className='overview-text'>Experience the best of Chitwan with a full suite of activities. From deep-jungle Jeep safaris and peaceful river canoeing to meeting the majestic residents of the Elephant Breeding Center, we bring you face-to-face with nature.</p>

  <div className="heading smalling">Iconic Himalayan Sunrises</div>
  <p className='overview-text'>We take you to the "Balcony of the Himalayas." By staying overnight in Nagarkot, you get an exclusive front-row seat to the sunrise over the Everest and Langtang ranges without the need for a strenuous trek.</p>

  <div className="heading smalling">Deep Cultural Immersion</div>
  <p className='overview-text'>Go beyond the typical tourist paths. We include comprehensive visits to the massive Bouddhanath Stupa, the hilltop Swayambhunath, and the medieval city of Bhaktapur to ensure a profound connection with Nepal's spiritual soul.</p>
</div>

<div className="overview-container">
  <div className="overview-heading"id='itinerary'>ITINERARY</div>
  
  {/* Day 1 */}
  <div className="timeline-row">
    <div className="timeline-left">
      <div className="day-circle">Day 1</div>
    </div>
    <div className="timeline-right" onClick={() => setDay1Open(!day1Open)}>
      <div className="timeline-title">Arrival & Kathmandu Exploration</div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day1Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>
  {day1Open && (
    <div className="timeline-detail">
      Welcome to Nepal! After airport pickup and hotel check-in, visit the sacred Boudhanath Stupa and the hilltop Swayambhunath (Monkey Temple) for stunning valley views and a peaceful introduction to Kathmandu's spiritual atmosphere.
    </div>
  )}

  {/* Day 2 */}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 2</div>
    </div>
    <div className="timeline-right" onClick={() => setDay2Open(!day2Open)}> 
      <div className="timeline-title">Drive to Chitwan & Tharu Culture</div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day2Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>
  {day2Open && (
    <div className="timeline-detail">
      Drive to Chitwan National Park. Upon arrival, enjoy a guided village walk to experience the lifestyle of the indigenous Tharu people. In the evening, witness a vibrant Tharu cultural dance performance followed by a riverside sunset view.
    </div>
  )}

  {/* Day 3 */}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 3</div>
    </div>
    <div className="timeline-right" onClick={() => setDay3Open(!day3Open)}> 
      <div className="timeline-title">Full Day Jungle Adventure</div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day3Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>
  {day3Open && (
    <div className="timeline-detail">
      A day of wilderness! Experience a serene canoe ride on the Rapti River to spot crocodiles, followed by a visit to the Elephant Breeding Center. The highlight is a thrilling Jeep safari deep into the park to encounter One-Horned Rhinos and exotic wildlife.
    </div>
  )}

  {/* Day 4 */}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 4</div>
    </div>
    <div className="timeline-right" onClick={() => setDay4Open(!day4Open)}> 
      <div className="timeline-title">Chitwan to Kathmandu Return</div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day4Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>
  {day4Open && (
    <div className="timeline-detail">
      After a morning of birdwatching, drive back to Kathmandu. Once you arrive, the rest of the afternoon is free for you to relax at your hotel or explore the vibrant local markets of Thamel for souvenirs and local cuisine.
    </div>
  )}

  {/* Day 5 */}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 5</div>
    </div>
    <div className="timeline-right" onClick={() => setDay5Open(!day5Open)}> 
      <div className="timeline-title">Bhaktapur Heritage & Nagarkot Sunset</div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day5Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>
  {day5Open && (
    <div className="timeline-detail">
      Explore the medieval city of Bhaktapur, famous for its 55-window palace and ancient pottery squares. Continue the scenic drive to Nagarkot hill station to witness a spectacular sunset over the Everest and Langtang Himalayan ranges.
    </div>
  )}

  {/* Day 6 */}
  <div className="timeline-row time-linemargin">
    <div className="timeline-left">
      <div className="day-circle">Day 6</div>
    </div>
    <div className="timeline-right" onClick={() => setDay6Open(!day6Open)}> 
      <div className="timeline-title">Sunrise & Farewell Departure</div>
      <div className="arrow-icon">
        <FontAwesomeIcon icon={day6Open ? faChevronUp : faChevronDown} />
      </div>
    </div>
  </div>
  {day6Open && (
    <div className="timeline-detail">
      Wake up for a breathtaking Himalayan sunrise. After breakfast, drive back to Kathmandu for any last-minute shopping. Finally, our team will transfer you to Tribhuvan International Airport for your departure flight back home.
    </div>
  )}
</div>


<div className="overview-container width-hund"id='included'>
  <div className="cost-box included">
    <div className="cost-title">Cost Included</div>
    <div className="cost-item">
      <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
      <div className="cost-text">All airport transfers and ground transportation in a private AC vehicle.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
      <div className="cost-text">Standard accommodation in Kathmandu, Chitwan, and Nagarkot with breakfast.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
      <div className="cost-text">Full board meals (Breakfast, Lunch, Dinner) during the Chitwan jungle stay.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
      <div className="cost-text">All jungle activities: Jeep Safari, Canoeing, and Elephant Breeding Center visit.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
      <div className="cost-text">Government licensed English-speaking guide for sightseeing and safari.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle green"><FontAwesomeIcon icon={faCheck} /></div>
      <div className="cost-text">All necessary National Park permits and entrance fees for heritage sites.</div>
    </div>
  </div>

  <div className="cost-box excluded">
    <div className="cost-title">Cost Not Included</div>
    <div className="cost-item">
      <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
      <div className="cost-text">International airfare and Nepal entry visa fees.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
      <div className="cost-text">Lunch and Dinner in Kathmandu and Nagarkot.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
      <div className="cost-text">Personal expenses: laundry, telephone calls, and bar bills.</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
      <div className="cost-text">Travel and medical insurance (highly recommended).</div>
    </div>
    <div className="cost-item">
      <div className="icon-circle red"><FontAwesomeIcon icon={faXmark} /></div>
      <div className="cost-text">Tips for driver, guide, and hotel staff.</div>
    </div>
  </div>
</div>


<div className="overview-container">
  <div className="heading vbn"><FontAwesomeIcon icon={faMessage}></FontAwesomeIcon> FAQS
  </div>
  <section className="faq">
      <div className="faq-container">

        <div className="faq-list">
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <div className="faq-question">
            Booking & Payment Terms
              <span>{activeIndex === 0 ? "-" : "+"}</span>
            </div>
            {activeIndex === 0 && (
              <div className="faq-answer">
               To confirm your trip, a 10% deposit is required at the time of booking. Upon your arrival in Nepal and transfer to your hotel, 70% of the total fee is due to begin the tour services. The remaining balance payment must be settled in full after the fourth day of your journey.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <div className="faq-question">
              How can I book a tour?
              <span>{activeIndex === 1 ? "-" : "+"}</span>
            </div>
            {activeIndex === 1 && (
              <div className="faq-answer">
                You can book directly from our website by clicking button  or contact our support team from right side contact details or from contact us page where is a QR for your ease scan and contactus.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <div className="faq-question">
              Is This Package Suitable For Me ?
              <span>{activeIndex === 2 ? "-" : "+"}</span>
            </div>
            {activeIndex === 2 && (
              <div className="faq-answer">
            This package is perfectly suited for first-time travelers and families looking for a comprehensive introduction to Nepal without the physical demands of high-altitude trekking. It balances the deep historical roots of the Kathmandu Valley’s ancient squares with the tranquil, natural beauty of Pokhara’s lakeside and caves. Because every destination is accessible by vehicle, it is an excellent choice for senior citizens, photographers, or time-constrained tourists who want to experience the "Golden Triangle" of Nepal’s heritage and Himalayan views in comfort and style.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(3)}>
            <div className="faq-question">
              Can I cancel my booking and refund policies?
              <span>{activeIndex === 3 ? "-" : "+"}</span>
            </div>
            {activeIndex === 3 && (
              <div className="faq-answer">
                Yes you can cancel. we understand life will not run according to our plan. There is refund policies Cancel up to 10 days before in advance for a full refund after 10 days there will no refund of your 10% payment.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(4)}>
            <div className="faq-question">
              Preparation For This package
              <span>{activeIndex === 4 ? "-" : "+"}</span>
            </div>
            {activeIndex === 4 && (
              <div className="faq-answer">
                 <div className="heading smalling">What to Bring:</div>
  <div className="flex-p">
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Travel Documents:</b> Ensure you have a valid passport and printed copies of your booking confirmation and insurance.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Comfortable Footwear:</b> Pack a pair of sturdy walking shoes or sneakers for navigating the stone pathways of Bhaktapur and the nature trails in Sarangkot.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Seasonal Layering:</b> Bring a warm jacket or fleece for the early morning sunrises in Nagarkot and Sarangkot, as temperatures drop significantly before dawn.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Personal Care:</b> Remember to pack sunscreen, sunglasses, and a hat to protect yourself from the strong high-altitude sun during your Phewa Lake boat ride.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Day Pack:</b> Use a small backpack to keep your camera, power bank, and rain gear handy for sudden mountain weather changes.</p>
  <p style={{padding:"3px"}}><FontAwesomeIcon icon={faArrowRight} style={{color:"green", fontSize:'18px'}}/> <b>Currency & Cash:</b> Keep some local currency (NPR) for personal expenses, tips, and meals not included in the package.</p>
  </div>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(5)}>
            <div className="faq-question">
              What about meal in this package?
              <span>{activeIndex === 5 ? "-" : "+"}</span>
            </div>
            {activeIndex === 5 && (
              <div className="faq-answer">
               <div className="heading smalling">Meal Plan Details</div>

<p className='overview-text'><b>Standard Inclusion:</b> Every morning begins with a fresh, delicious breakfast included at your hotel to fuel your day of exploration. This ensures you start your journey energized and ready for the sights ahead.</p>

<p className='overview-text'><b>Lunch & Dinner (Flexible):</b> To give you complete freedom over your palate, these meals are not included in the base price. Your guide will introduce you to top-rated local restaurants where you can pay directly, allowing you to discover the diverse flavors of Nepal at your own pace.</p>

<p className='overview-text'><b>Full-Board Upgrade (Recommended):</b> For those seeking a truly seamless and worry-free adventure, we can include all lunch and dinner charges in your package. We will handle all the arrangements and payments at every destination, so your only responsibility is to sit back, relax, and enjoy the trip.</p>
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(6)}>
            <div className="faq-question">
              Do you provide customized tours?
              <span>{activeIndex === 6 ? "-" : "+"}</span>
            </div>
            {activeIndex === 6 && (
              <div className="faq-answer">
                Yes, we offer fully customizable travel experiences you can see button of customize below just click it and our travel expert will contact you.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(7)}>
            <div className="faq-question">
              What Language are available for this package?
              <span>{activeIndex === 7 ? "-" : "+"}</span>
            </div>
            {activeIndex === 7 && (
              <div className="faq-answer">
                Our guides speak English, Hindi, and Chinese.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(8)}>
            <div className="faq-question">
              Do you offer group discounts?
              <span>{activeIndex === 8 ? "-" : "+"}</span>
            </div>
            {activeIndex === 8 && (
              <div className="faq-answer">
                When you see right side in desktop and little bit below in mobile screen we made a system where total price is calculated according to number of people and there may be available of more discount for group which is not mention in this system than our booking team will mention it while enquiry or booking.
              </div>
            )}
          </div>

          <div className="faq-item" onClick={() => toggleFaq(9)}>
            <div className="faq-question">
              How can I contact support?
              <span>{activeIndex === 9 ? "-" : "+"}</span>
            </div>
            {activeIndex === 9 && (
              <div className="faq-answer">
                You can reach us via email, phone and many more just see our contact us page.
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  </div>
<div className="overview-container">
  <div className="heading">Why Choose Us ?</div>

  <div className="flex-p">
   <p>1. From past 7 years we are continuously providing great service to our customer.</p>
   <p>2. After Booking with us your task is only to enjoy your trip.</p>
   <p>3. You can customize your holiday with our Destination expert.</p>
   <p>4. Providing better quality in compitative price is our main goal.</p>
   <p>5. Until your depature to your own country all responsibility like security is our duty.</p>
  </div>
</div>
<div className="overview-container width-hund">
<div className="review-section">

<div className="review-heading">
  What Our Travelers Say
</div>

<div className="review-wrapper">

  {/* REVIEW 1 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      The Everest Heli Tour was a dream come true. The views were unreal and
      the helicopter experience was smooth and luxurious.
    </div>

    <div className="review-user">
      <div className="user-avatar">A</div>
      <div className="user-info">
        <div className="user-name">Alex Morgan</div>
        <div className="user-country">United Kingdom</div>
      </div>
    </div>
  </div>

  {/* REVIEW 2 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Perfect for travelers with limited time. In just a few hours, we saw
      Everest up close without any physical effort.
    </div>

    <div className="review-user">
      <div className="user-avatar">S</div>
      <div className="user-info">
        <div className="user-name">Sophia Lee</div>
        <div className="user-country">Singapore</div>
      </div>
    </div>
  </div>

  {/* REVIEW 3 */}
  <div className="review-card">
    <div className="review-stars">
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
      <FontAwesomeIcon icon={faStar} />
    </div>

    <div className="review-text">
      Highly recommended! Stunning mountain views, professional crew, and
      an unforgettable helicopter flight over the Himalayas.
    </div>

    <div className="review-user">
      <div className="user-avatar">R</div>
      <div className="user-info">
        <div className="user-name">Rahul Verma</div>
        <div className="user-country">India</div>
      </div>
    </div>
  </div>

</div>
</div>
</div>
<div className="cta-section">

<div className="cta-button book" onClick={()=>seT(true)}>
  <FontAwesomeIcon icon={faCalendarCheck} />
  <div className="cta-text">Book Now</div>
</div>

<div className="cta-button customize" onClick={()=>seTe(true)}>
  <FontAwesomeIcon icon={faSliders} />
  <div className="cta-text">Customize</div>
</div>

<div className="cta-button review" onClick={()=>seTr(true)}>
  <FontAwesomeIcon icon={faStar} />
  <div className="cta-text">Review</div>
</div>

</div>
    </div>
    <section id='price'>
    <div className='Right'>
        <div className="in-right">
         <div className="out-right">
            <div className="out-in-right"> 
            <h3>Starting Price</h3>
            <div className="price-tag">
              <div className="icon-price-tag">
               <FontAwesomeIcon icon={faTag} className='icon'/>
              </div>
              <div className="icon-details">
                 <div className="right-price">
                  <p>$1150</p>
                  <p className="per-person">/Per Person</p>
                 </div>
                 <p className='little'>All Price Inclusive</p>
            </div>
            </div>
            </div>
            <div className="number-of-traveller">
              <p>Number Of Travellers</p>
              <p className='lt'><FontAwesomeIcon icon={faBolt}></FontAwesomeIcon>Price Decreases When Travellers Increases</p>
              <div className="people-box">
              <FontAwesomeIcon icon={faMinus} className='people-box-icon'onClick={()=>{if(count>1){Setcount(count-1)}}}/>
                <p className='count'>{count}</p>
                <FontAwesomeIcon icon={faPlus} className='people-box-icon'onClick={()=>{Setcount(count+1)}}/>
              </div>
              <div className='Total-Amount'>
                <p className='total-price'>Total Amount</p>
                <p>${totalprice}</p>
              </div>
              <div className="booking-button">
                <Link to="/Terms" className="download">
                  
                  <h6>See Terms & Conditions</h6>
                </Link>
                <div className="booking-btn">
                  <button onClick={()=>seT(true)}>Book Now</button>
                  <button onClick={()=>seTe(true)}>Enquiry Now</button>
                </div>
              </div>
            </div>
         </div>
         </div>
         <div className="tour-rep-section">
      <h2 className="section-heading">Trip Expert</h2>
      
       <div className="rep-card">
        <div className="image-container">
          <img 
            src="/img/company/destination expert.png" 
            alt="Sales Manager" 
            className="rep-image" 
          />
        </div>
        
        <div className="rep-info">
          <h3 className="rep-name">Bishnu Pandey</h3>
           <div className="contact-item">
            <FontAwesomeIcon icon={faWhatsapp} className="icon effect" />
            <span>+977-9863841456</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faWeixin} className="icon effect" />
            <span>Bishnu Pandey</span>
          </div>
          
          <div className="contact-item">
            <FontAwesomeIcon icon={faEnvelope} className="icon" />
            <a href="mailto:sales@yourtravelco.com">012shy1234@gmail.com</a>
          </div>
        </div>
      </div>
    </div>
        </div>
        </section>
   </div>
     <h2 className="hws">Similar Packages</h2>
     <PackageSlider packages={packages} />
     <section className='sticky-bott'>
     <div className="booking-btn">
      <button onClick={()=>seT(true)}>Book Now</button>
      <button onClick={()=>seTe(true)}>Enquiry Now</button>
      </div>
     </section>
     {opent &&( 
      <section className="bookings">
      <div
      className="sw"
      onClick={() => seT(false)}
    >
      Back
      
    </div>
   <Bookingform src="/img/chitwan/chitwan3dslr" title="Peak & Safaris"/></section>
     )}
{opente &&( 
  <section className="bookings">
      <div
      className="sw"
      onClick={() => seTe(false)}
    >
      Back
      
    </div>
    <Enquiryform src="/img/chitwan/chitwan3dslr" title="Peak & Safaris"/></section>
  
)}
{openr &&( 
  <section className="bookings">
  <div
  className="sw"
  onClick={() => seTr(false)}
>
  Back
  
</div>
<Review /></section>
 
)}
   </main>
  )
}
export default KathmanduchitwannagarkotTour